// Componente para proteger rotas
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/auth-hook';
import { useI18n } from '@/contexts/i18n-hook';

interface ProtectedRouteProps {
  children: ReactNode;
  requireAdmin?: boolean;
  requireRole?: string;
}

export function ProtectedRoute({ children, requireAdmin = false, requireRole }: ProtectedRouteProps) {
  const { isAdmin, isAuthenticated, loading, user } = useAuth();
  const { t } = useI18n();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <p className="text-gray-600 dark:text-gray-400">{t('auth.rota.carregandoSessao')}</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
            {t('auth.rota.acessoNegado')}
          </h1>
          <p className="text-gray-600 dark:text-gray-400">
            {t('auth.rota.semPermissaoPagina')}
          </p>
        </div>
      </div>
    );
  }

  if (requireRole && user?.role !== requireRole) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
            {t('auth.rota.acessoNegado')}
          </h1>
          <p className="text-gray-600 dark:text-gray-400">
            {t('auth.rota.semPermissaoArea')}
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
